import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  userAccessRightsSuccess,
  userLoginErrorMsg,
  userLoginSuccessMsg,
  userProfileFetchSuccess,
} from "./reducer";
import { loginApi, logoutApi } from "services/authServcies";
import { useNavigate } from "react-router-dom";
// Utility to normalize error object
const formatError = (error: any): { data: string } => ({
  data:
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong. Please try again.",
});

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const response = await loginApi({
      username: user.username,
      password: user.password, });

    if (response.success) {
      // Save authUser to sessionStorage
      sessionStorage.setItem("authUser", JSON.stringify(response.data));
      sessionStorage.setItem("isLoggedIn", "true");

  
      // Show success message
      dispatch(userLoginSuccessMsg(response.message || "Login Successful"));


      const adminData = {
        username: response.data.username,
        phone_no: response.data.phone_no,
        email_id: response.data.email_id,
      }

      // Fetch user profile
      try {
        // const userProfile = await getLoggedinUser();
        const userProfile = true;
        console.log("userProfile....", userProfile);

        // const accessrights = userProfile?.data?.useraccessrights
        
        if (userProfile) {
          dispatch(loginSuccess());
          // dispatch(userProfileFetchSuccess(adminData));
          dispatch(userProfileFetchSuccess(adminData));
          // dispatch(userAccessRightsSuccess(accessrights));
        } else {
          dispatch(apiError({ data: "Failed to load user profile." }));
        }
      } catch (error) {
        dispatch(apiError(formatError(error)));
        console.error("Failed to fetch user profile after login", error);
      }

      // Navigate to dashboard
      
      history("/dashboard");

      // Clear login flags after delay
      setTimeout(() => {
        dispatch(reset_login_flag());
      }, 5000);
    } else {
      dispatch(apiError({ data:  "Login failed" }));
      dispatch(userLoginErrorMsg(response.message||" Please check username or password"));

    }
  } catch (loginError: any) {
    const errorMessage =   "Login error. Please try again.";
    dispatch(userLoginErrorMsg(loginError?.response?.data?.message||errorMessage ));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    const response = {
      success: true
    };

    if (response?.success) {
      sessionStorage.removeItem("authUser");  
      sessionStorage.removeItem("isLoggedIn");  
      localStorage.setItem("logout", Date.now().toString()); // signal other tabs
      dispatch(logoutUserSuccess());
      return "Logout successful";
    } else {
      dispatch(apiError({ data: "Logout failed" }));
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

// Example placeholder for social login (optional)
export const socialLogin = (type: any, history: any) => async (dispatch: any) => {
  const navigate = useNavigate()
  try {
    // Simulated response (replace with actual logic)
    let response; // Placeholder
    const socialdata = await response;

    if (socialdata) {
      sessionStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      navigate("/dashboard");
    }
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(formatError(error)));
  }
};
